import { navigateTo } from 'front-end/src/app/util/appHistory'
import { AnalyticsFilterDefaultValues } from 'front-end/src/pages/analytics/AnalyticsContext'

export const navigateToAndResetPageAndSearch = (path, changeFilter) => {
  navigateTo(path, true)
  changeFilter(
    {
      page: AnalyticsFilterDefaultValues.page,
      search: AnalyticsFilterDefaultValues.search
    },
    'replaceIn'
  )
}
